import React from 'react'
import { cva } from 'class-variance-authority'
import { cn } from '../../lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded px-2.5 py-0.5 text-xs font-semibold transition-opacity duration-50 focus:outline-none focus:ring-2 focus:ring-[#0052CC] focus:ring-offset-2 font-[system-ui]',
  {
    variants: {
      variant: {
        default: 'border border-[#D1D5DB] bg-[#F5F5F5] text-[#1F2937]',
        secondary: 'border border-[#D1D5DB] bg-white text-[#1F2937]',
        destructive: 'border border-red-200 bg-red-50 text-red-900',
        accent: 'border border-blue-200 bg-blue-50 text-blue-900',
        outline: 'border border-[#D1D5DB] text-[#1F2937]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

const Badge = React.forwardRef(({ className, variant, ...props }, ref) => {
  return (
    <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
  )
})
Badge.displayName = 'Badge'

export { Badge, badgeVariants } 